export default __webpack_public_path__ + "static/media/group.92a45da1.svg";